(function () {
  'use strict';

  var ROOT_ID = 'dcpaste';
  var PHONE_HREF = '+14056170717';
  var PHONE_LABEL = '(405) 617-0717';
  var CHEMISTRY = {
    '101': 'Iron Oxide Red',
    '102': 'Carbon Black',
    '119': 'Iron Oxide Yellow',
    '201': 'Copper Phthalocyanine',
    '204': 'Chromium Oxide Green',
    '205': 'Titanium Dioxide',
    '206': 'Iron Oxide Black'
  };
  var LOW_DOSE = { '102': true, '201': true };
  var activeCard = null;
  var activeDetail = null;
  var activeMediaCard = null;
  var requestedMediaCard = null;
  var mediaRequestSerial = 0;

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function icon(name, size) {
    var paths = {
      calc: '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h8M8 11h2M12 11h2M16 11h.01M8 15h2M12 15h2M16 15h.01"/>',
      cart: '<circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.55L21 8H6"/>',
      phone: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.62 2.63a2 2 0 0 1-.45 2.11L8 9.73a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.85.3 1.73.5 2.63.62A2 2 0 0 1 22 16.92z"/>',
      stock: '<path d="M20 6 9 17l-5-5"/>',
      arrow: '<path d="m9 18 6-6-6-6"/>'
    };
    return '<svg viewBox="0 0 24 24" width="' + (size || 20) + '" height="' + (size || 20) + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (paths[name] || '') + '</svg>';
  }

  function cardCode(card) {
    var controlled = card && card.getAttribute('aria-controls');
    if (controlled) return controlled.replace(/^dcpd/, '');
    var code = card && card.querySelector('.cd');
    return code ? code.textContent.trim() : '';
  }

  function cardName(card) {
    var name = card && card.querySelector('.nm');
    return name ? name.textContent.trim() : '';
  }

  function cardColor(card) {
    var swatch = card && card.querySelector('.lad i');
    return swatch ? window.getComputedStyle(swatch).backgroundColor : '#e7edf6';
  }

  function productMediaMap(root) {
    if (!root) return {};
    if (root._dcPasteMediaMap) return root._dcPasteMediaMap;
    var data = root.querySelector('[data-paste-media-map]');
    var entries = [];
    var map = {};
    if (data) {
      try { entries = JSON.parse(data.textContent || '[]'); } catch (error) { entries = []; }
    }
    if (Array.isArray(entries)) {
      entries.forEach(function (entry) {
        var code = String(entry && entry.code || '');
        var variantId = parseInt(entry && entry.variantId, 10);
        var mediaId = parseInt(entry && entry.mediaId, 10);
        var position = parseInt(entry && entry.position, 10);
        var src = typeof (entry && entry.src) === 'string' ? entry.src : '';
        var alt = typeof (entry && entry.alt) === 'string' ? entry.alt : '';
        if (code && variantId > 0 && mediaId > 0) {
          map[code] = {
            variantId: variantId,
            mediaId: mediaId,
            position: position > 0 ? position : 1,
            src: src,
            alt: alt
          };
        }
      });
    }
    root._dcPasteMediaMap = map;
    return map;
  }

  function prepareMobileMedia(root) {
    var sectionRoot = root && root.closest ? root.closest('[id^="MainPasteProduct-"]') : null;
    var container = sectionRoot && sectionRoot.querySelector('.product__media-container');
    var image = sectionRoot && sectionRoot.querySelector('[data-paste-mobile-image]');
    var map = productMediaMap(root);
    var cards = root ? Array.prototype.slice.call(root.querySelectorAll('#dcpasteGrid > .sw')) : [];
    var allCardsHaveImages = cards.length > 0 && cards.every(function (card) {
      var target = map[cardCode(card)];
      return Boolean(target && target.src);
    });
    if (!sectionRoot || !container || !image || !allCardsHaveImages) {
      if (container) container.classList.remove('has-dc-paste-mobile-hero');
      syncMobileGalleryState(root);
      return false;
    }

    container.classList.add('has-dc-paste-mobile-hero');
    var hero = sectionRoot.querySelector('[data-paste-mobile-hero]');
    var initialMediaId = hero && hero.getAttribute('data-media-id');
    if (!activeMediaCard && initialMediaId) {
      Object.keys(map).some(function (code) {
        if (String(map[code].mediaId) !== String(initialMediaId)) return false;
        var initialCard = root.querySelector('#dcpc' + code);
        if (initialCard) selectMediaCard(root, initialCard);
        return Boolean(initialCard);
      });
    }
    syncMobileGalleryState(root);
    return true;
  }

  function syncMobileGalleryState(root) {
    var sectionRoot = root && root.closest ? root.closest('[id^="MainPasteProduct-"]') : null;
    var container = sectionRoot && sectionRoot.querySelector('.product__media-container');
    var gallery = container && container.querySelector('media-gallery.product__media-gallery');
    if (!gallery) return;
    var mobileViewport = window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
    var hideGallery = Boolean(mobileViewport && container.classList.contains('has-dc-paste-mobile-hero'));
    if (hideGallery) {
      if (gallery.contains(document.activeElement)) {
        var focusTarget = activeMediaCard || root.querySelector('#dcpasteGrid > .sw');
        if (focusTarget) {
          try { focusTarget.focus({ preventScroll: true }); } catch (error) { focusTarget.focus(); }
        }
      }
      gallery.setAttribute('aria-hidden', 'true');
      gallery.setAttribute('inert', '');
    } else {
      gallery.removeAttribute('aria-hidden');
      gallery.removeAttribute('inert');
    }
  }

  function usesMobileHero(root) {
    var sectionRoot = root && root.closest ? root.closest('[id^="MainPasteProduct-"]') : null;
    var container = sectionRoot && sectionRoot.querySelector('.product__media-container');
    var mobileViewport = window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
    return Boolean(mobileViewport && container && container.classList.contains('has-dc-paste-mobile-hero'));
  }

  function selectMediaCard(root, card) {
    var sectionRoot = root && root.closest ? root.closest('[id^="MainPasteProduct-"]') : null;
    if (!sectionRoot) return;
    Array.prototype.forEach.call(root.querySelectorAll('#dcpasteGrid > .sw'), function (candidate) {
      var selected = candidate === card;
      candidate.classList.toggle('is-media-selected', selected);
      candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    activeMediaCard = card;
  }

  function activateMobileMedia(root, sectionRoot, target, card, requestToken) {
    var hero = sectionRoot && sectionRoot.querySelector('[data-paste-mobile-hero]');
    var image = hero && hero.querySelector('[data-paste-mobile-image]');
    var source = hero && hero.querySelector('[data-paste-mobile-source]');
    if (!hero || !image || !target || !target.src) return false;

    var name = cardName(card);
    var alt = target.alt || (name + ' paste product image');
    if (name && alt.toLowerCase().indexOf(name.toLowerCase()) === -1) alt = name + ' — ' + alt;
    var status = hero.querySelector('[data-paste-mobile-status]');
    var requestedMediaId = String(target.mediaId);
    hero.setAttribute('data-requested-media-id', requestedMediaId);
    var commit = function () {
      if (requestToken !== mediaRequestSerial || requestedMediaCard !== card || !usesMobileHero(root)) return;
      if (hero.getAttribute('data-requested-media-id') !== requestedMediaId) return;
      if (source) source.srcset = target.src;
      image.src = target.src;
      image.alt = alt;
      image.setAttribute('data-media-id', requestedMediaId);
      hero.setAttribute('data-media-id', requestedMediaId);
      selectMediaCard(root, card);
      if (status) status.textContent = 'Showing ' + name + ' product image.';
    };

    var currentSource = source && source.getAttribute('srcset');
    if ((currentSource === target.src || image.getAttribute('src') === target.src) && image.complete && image.naturalWidth > 0) {
      commit();
      return true;
    }

    var preload = new Image();
    preload.onload = commit;
    preload.onerror = function () {
      if (requestToken !== mediaRequestSerial || requestedMediaCard !== card || !usesMobileHero(root)) return;
      if (hero.getAttribute('data-requested-media-id') !== requestedMediaId) return;
      hero.removeAttribute('data-requested-media-id');
      requestedMediaCard = activeMediaCard;
      if (status) status.textContent = name + ' product image could not be loaded. The previous image remains displayed.';
    };
    preload.src = target.src;
    return true;
  }

  function galleryShowsMedia(gallery, mediaId) {
    var active = gallery && gallery.querySelector('.product__media-item.swiper-slide-active[data-media-id], .product__media-item.is-active[data-media-id]');
    return Boolean(active && String(active.getAttribute('data-media-id')) === String(mediaId));
  }

  function activateProductMedia(root, card) {
    requestedMediaCard = card;
    var requestToken = ++mediaRequestSerial;
    var target = productMediaMap(root)[cardCode(card)];
    var sectionRoot = root && root.closest ? root.closest('[id^="MainPasteProduct-"]') : null;
    if (usesMobileHero(root)) return activateMobileMedia(root, sectionRoot, target, card, requestToken);
    var gallery = sectionRoot && sectionRoot.querySelector('media-gallery.product__media-gallery');
    if (!target || !gallery || typeof gallery.setActiveMedia !== 'function') return false;
    if ((gallery.dataset && gallery.dataset.hideVariantMedia === 'true') || gallery.hideVariantMedia === true) return false;
    try {
      gallery.setActiveMedia({
        id: target.variantId,
        featured_media: { id: target.mediaId, position: target.position }
      });
      window.setTimeout(function () {
        if (requestToken !== mediaRequestSerial || requestedMediaCard !== card || usesMobileHero(root)) return;
        if (!galleryShowsMedia(gallery, target.mediaId)) return;
        selectMediaCard(root, card);
        var status = gallery.querySelector('[id^="GalleryStatus"]');
        if (status) status.textContent = 'Showing ' + cardName(card) + ' product image.';
      }, 350);
      return true;
    } catch (error) {
      return false;
    }
  }

  function enhanceTitle(root) {
    var title = root.querySelector(':scope > h2');
    if (title) {
      title.classList.add('dc-paste-title');
      title.removeAttribute('style');
    }
    var grid = root.querySelector('#dcpasteGrid');
    if (!grid || root.querySelector('.dc-paste-intro')) return;
    var intro = document.createElement('p');
    intro.className = 'dc-paste-intro';
    intro.textContent = 'Seven premixed liquid colors in 2 lb and 44 lb packs.';
    grid.parentNode.insertBefore(intro, grid);
  }

  function supportHTML() {
    return '<nav class="dc-paste-support" aria-label="Paste buying help">' +
      '<a href="tel:' + PHONE_HREF + '">' + icon('phone', 20) + '<span><b>Pro Line</b> · ' + PHONE_LABEL + '</span>' + icon('arrow', 18) + '</a>' +
      '</nav>';
  }

  function enhanceDetail(detail) {
    if (detail.getAttribute('data-dc-enhanced') === 'true') return;
    detail.setAttribute('data-dc-enhanced', 'true');

    var code = detail.id.replace(/^dcpd/, '');
    var oldTitle = detail.querySelector(':scope > h3');
    var oldSub = detail.querySelector(':scope > .sub');
    var name = oldTitle ? oldTitle.textContent.trim() : ('Paste ' + code);
    var form = detail.querySelector('form.dcbuy');
    var available = !!form && parseInt(form.getAttribute('data-avail-count'), 10) > 0;
    var close = detail.querySelector(':scope > [data-close]');
    var body = detail.querySelector('.detbody');
    var oldMain = detail.querySelector(':scope > .detmain');
    var label = detail.querySelector(':scope > .lab');
    var steps = detail.querySelector(':scope > .steps');
    var finalNote = null;
    var directNotes = detail.querySelectorAll(':scope > .note');
    if (directNotes.length) finalNote = directNotes[directNotes.length - 1];

    if (oldSub) oldSub.remove();
    if (body) {
      var spec = body.querySelector(':scope > .spec');
      if (spec) spec.remove();
    }

    var header = document.createElement('header');
    header.className = 'dc-paste-detail-head';
    header.innerHTML = '<div><h3>' + escapeHTML(name) + '</h3><p>Code ' + escapeHTML(code) + ' · ' + escapeHTML(CHEMISTRY[code] || 'Pigment Paste') + '</p></div>' +
      '<span class="dc-paste-stock ' + (available ? 'is-available' : 'is-unavailable') + '">' + (available ? icon('stock', 18) + ' In stock' : 'Unavailable') + '</span>';
    detail.insertBefore(header, detail.firstChild);
    if (oldTitle) oldTitle.remove();

    if (close) {
      close.className = 'dc-paste-close';
      close.setAttribute('aria-label', 'Close ' + name);
      close.innerHTML = '<span aria-hidden="true">×</span><span class="dc-wide-copy">Close</span>';
      header.appendChild(close);
    }

    var layout = document.createElement('div');
    layout.className = 'dc-paste-layout';
    header.insertAdjacentElement('afterend', layout);

    var dosePanel = document.createElement('section');
    dosePanel.className = 'dc-paste-dose-panel';
    dosePanel.innerHTML = '<div class="dc-paste-panel-title"><div><h4>Loading levels</h4><p>Finished-color examples over grey cement</p></div></div>';
    if (label) label.remove();
    if (steps) {
      Array.prototype.forEach.call(steps.querySelectorAll('.tx b'), function (doseLine) {
        var parts = doseLine.textContent.split('·');
        if (parts.length < 2) return;
        doseLine.textContent = parts.shift().trim();
        var perYard = document.createElement('span');
        perYard.textContent = parts.join('·').trim();
        doseLine.insertAdjacentElement('afterend', perYard);
      });
      dosePanel.appendChild(steps);
    }
    if (finalNote) dosePanel.appendChild(finalNote);
    dosePanel.insertAdjacentHTML('beforeend', '<a class="dc-paste-panel-action dc-paste-panel-calculator" href="#dcPasteCalc">' +
      icon('calc', 19) + '<span>Not sure how much to buy? <u>Use our paste calculator</u></span>' + icon('arrow', 18) + '</a>');
    layout.appendChild(dosePanel);

    var purchase = document.createElement('section');
    purchase.className = 'dc-paste-purchase-panel';
    purchase.innerHTML = '<div class="dc-paste-panel-title"><div><h4>Choose pack size and quantity</h4><p>Net weight</p></div></div>';
    if (body) {
      while (body.firstChild) purchase.appendChild(body.firstChild);
    }
    purchase.insertAdjacentHTML('beforeend', '<a class="dc-paste-panel-action dc-paste-mobile-bulk" href="tel:' + PHONE_HREF + '">' +
      icon('phone', 19) + '<span>Ordering 100+ lbs? <u>Get bulk pricing</u></span>' + icon('arrow', 18) + '</a>');
    layout.appendChild(purchase);
    if (oldMain) oldMain.remove();

    detail.insertAdjacentHTML('beforeend', supportHTML());
  }

  function columnCount(grid) {
    var columns = window.getComputedStyle(grid).gridTemplateColumns;
    if (!columns || columns === 'none') return 1;
    return columns.split(' ').filter(function (part) { return part; }).length || 1;
  }

  function placeDetail(grid, card, detail) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .sw'));
    var index = cards.indexOf(card);
    if (index < 0) return;
    var end = Math.min(cards.length - 1, (Math.floor(index / columnCount(grid)) + 1) * columnCount(grid) - 1);
    grid.insertBefore(detail, cards[end].nextSibling);
  }

  function closeDetail(focusCard) {
    if (activeCard) {
      activeCard.setAttribute('aria-expanded', 'false');
      activeCard.classList.remove('is-selected');
    }
    if (activeDetail) activeDetail.hidden = true;
    var previousCard = activeCard;
    activeCard = null;
    activeDetail = null;
    if (focusCard && previousCard) previousCard.focus();
  }

  function syncCalculator(root, code) {
    var calculator = root.querySelector('#dcPasteCalc');
    var select = calculator && calculator.querySelector('[data-paste-color]');
    if (!select) return;
    select.value = code;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function openDetail(root, card, shouldScroll) {
    var id = card.getAttribute('aria-controls');
    var detail = id && document.getElementById(id);
    var grid = root.querySelector('#dcpasteGrid');
    if (!detail || !grid) return;
    if (activeCard === card && !detail.hidden) {
      closeDetail(false);
      return;
    }
    closeDetail(false);
    placeDetail(grid, card, detail);
    card.setAttribute('aria-expanded', 'true');
    card.classList.add('is-selected');
    detail.hidden = false;
    activeCard = card;
    activeDetail = detail;
    activateProductMedia(root, card);
    syncCalculator(root, cardCode(card));
    if (shouldScroll && detail.scrollIntoView) {
      try { detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (error) {}
    }
  }

  /* A link can say what to open: ?variant=<id> or ?color=101. Same rule as the powder page. */
  function openFromLink(root, search) {
    var params = new URLSearchParams(typeof search === 'string' ? search : window.location.search);
    var variant = params.get('variant');
    var code = params.get('color');
    var radio = null;
    if (variant && /^\d+$/.test(variant)) {
      radio = root.querySelector('input.dcsz[value="' + variant + '"]');
      var holder = radio && radio.closest('[id^="dcpd"]');
      if (holder) code = holder.id.replace('dcpd', '');
    }
    if (!code || !/^\d{3}$/.test(code)) return false;
    var card = root.querySelector('#dcpc' + code);
    var id = card && card.getAttribute('aria-controls');
    var detail = id && document.getElementById(id);
    if (!detail) return false;
    if (activeCard !== card || detail.hidden) openDetail(root, card, false);
    if (radio && !radio.disabled && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    window.requestAnimationFrame(function () {
      var box = detail.getBoundingClientRect();
      detail.scrollIntoView({ block: box.height < window.innerHeight * 0.75 ? 'center' : 'start' });
    });
    return true;
  }

  function dosesFor(code) {
    return LOW_DOSE[code] ? [0.5, 1, 1.5, 2] : [1, 3, 5, 7];
  }

  function doseOptions(code, selected) {
    return dosesFor(code).map(function (dose) {
      return '<option value="' + dose + '"' + (String(dose) === String(selected) ? ' selected' : '') + '>' + dose + ' lb per cement sack</option>';
    }).join('');
  }

  function roundOne(value) {
    return Math.round(value * 10) / 10;
  }

  function packaging(needed) {
    var large = Math.floor(needed / 44);
    var remainder = needed - (large * 44);
    var small = Math.ceil(Math.max(0, remainder) / 2);
    if (small >= 22) { large += 1; small = 0; }
    if (!large && !small && needed > 0) small = 1;
    return { large: large, small: small, supplied: large * 44 + small * 2 };
  }

  function availablePackVariants(root, code) {
    var detail = root.querySelector('#dcpd' + code);
    var radios = detail ? detail.querySelectorAll('form.dcbuy input.dcsz:not(:disabled)') : [];
    var variants = {};
    Array.prototype.forEach.call(radios, function (radio) {
      var size = Math.round(parseFloat(radio.getAttribute('data-size')) || 0);
      var id = parseInt(radio.value, 10);
      if ((size === 2 || size === 44) && id > 0) variants[size] = { id: id, size: size };
    });
    return variants;
  }

  function purchasablePackaging(needed, variants) {
    var packs = { large: 0, small: 0, supplied: 0, picks: [] };
    if (!(needed > 0)) return packs;
    if (variants[44] && variants[2]) {
      packs = packaging(needed);
      packs.picks = [];
    } else if (variants[44]) {
      packs.large = Math.ceil(needed / 44);
      packs.supplied = packs.large * 44;
    } else if (variants[2]) {
      packs.small = Math.ceil(needed / 2);
      packs.supplied = packs.small * 2;
    }
    if (packs.large && variants[44]) packs.picks.push({ id: variants[44].id, quantity: packs.large, size: 44 });
    if (packs.small && variants[2]) packs.picks.push({ id: variants[2].id, quantity: packs.small, size: 2 });
    return packs;
  }

  function calculatorHTML(cards) {
    var options = cards.map(function (card) {
      var code = cardCode(card);
      return '<option value="' + escapeHTML(code) + '">' + escapeHTML(cardName(card)) + ' · Code ' + escapeHTML(code) + '</option>';
    }).join('');
    var firstCode = cards.length ? cardCode(cards[0]) : '101';
    return '<header class="dc-paste-calc-head"><span>' + icon('calc', 28) + '</span><div><h2>How much paste do you need?</h2><p>Choose a color, confirm the dose, and enter your project size.</p></div></header>' +
      '<div class="dc-paste-calc-body">' +
        '<div class="dc-paste-calc-fields">' +
          '<label><span>Paste color</span><select data-paste-color>' + options + '</select></label>' +
          '<label><span>Dose</span><select data-paste-dose>' + doseOptions(firstCode, dosesFor(firstCode)[0]) + '</select></label>' +
          '<label><span>Project size</span><span class="dc-paste-calc-qty"><button type="button" data-calc-minus aria-label="Decrease project size">−</button><input type="number" min="0.5" step="0.5" value="5" inputmode="decimal" data-paste-amount><button type="button" data-calc-plus aria-label="Increase project size">+</button></span></label>' +
          '<label><span>Project unit</span><select data-paste-unit><option value="sack">94 lb cement sacks</option><option value="cy">Cubic yards · 5-sack mix</option></select></label>' +
        '</div>' +
        '<aside class="dc-paste-calc-result" aria-live="polite" data-paste-result></aside>' +
      '</div>' +
      '<footer><span>Estimate only; final color depends on materials, water, curing, and finish.</span><a href="tel:' + PHONE_HREF + '">' + icon('phone', 18) + ' Need help? Call Pro Line · ' + PHONE_LABEL + '</a></footer>';
  }

  function installCalculator(root) {
    var grid = root.querySelector('#dcpasteGrid');
    var cards = Array.prototype.slice.call(root.querySelectorAll('#dcpasteGrid > .sw'));
    if (!grid || !cards.length) return;
    var calculator = root.querySelector('#dcPasteCalc');
    if (!calculator) {
      calculator = document.createElement('section');
      calculator.id = 'dcPasteCalc';
      calculator.className = 'dc-paste-calculator';
      grid.insertAdjacentElement('afterend', calculator);
    }
    if (calculator.getAttribute('data-dc-wired') === 'true') return;
    calculator.setAttribute('data-dc-wired', 'true');
    calculator.innerHTML = calculatorHTML(cards);

    var color = calculator.querySelector('[data-paste-color]');
    var dose = calculator.querySelector('[data-paste-dose]');
    var amount = calculator.querySelector('[data-paste-amount]');
    var unit = calculator.querySelector('[data-paste-unit]');
    var result = calculator.querySelector('[data-paste-result]');

    function calculate() {
      var code = color.value;
      var card = cards.filter(function (candidate) { return cardCode(candidate) === code; })[0] || cards[0];
      var name = cardName(card);
      var doseValue = parseFloat(dose.value) || dosesFor(code)[0];
      var project = Math.max(0, parseFloat(amount.value) || 0);
      var sacks = unit.value === 'cy' ? project * 5 : project;
      var needed = roundOne(sacks * doseValue);
      var variants = availablePackVariants(root, code);
      var packs = purchasablePackaging(needed, variants);
      var packParts = [];
      if (packs.large) packParts.push(packs.large + ' × 44 lb');
      if (packs.small) packParts.push(packs.small + ' × 2 lb');
      var formula = unit.value === 'cy'
        ? project + ' cu yd × 5 sacks × ' + doseValue + ' lb'
        : project + ' sacks × ' + doseValue + ' lb';
      var packCount = packs.large + packs.small;
      var cartItems = packs.picks.map(function (pick) {
        return {
          id: pick.id,
          quantity: pick.quantity,
          properties: {
            'Paste color': name + ' (Code ' + code + ')',
            'Dose estimate': doseValue + ' lb per 94 lb cement sack',
            'Estimated need': needed + ' lb paste'
          }
        };
      });
      var action = packs.picks.length
        ? '<button class="dc-paste-calc-atc" type="button" data-calc-add>' + icon('cart', 19) + '<span class="dc-wide-copy">Add ' + packCount + ' pack' + (packCount === 1 ? '' : 's') + ' to cart</span><span class="dc-mobile-copy">Add to cart</span></button>'
        : '<button class="dc-paste-calc-atc" type="button" disabled>No available pack sizes</button>';
      result.innerHTML = '<div class="dc-paste-result-color"><i style="background:' + escapeHTML(cardColor(card)) + '"></i><span><b>' + escapeHTML(name) + '</b><small>Code ' + escapeHTML(code) + '</small></span></div>' +
        '<div class="dc-paste-result-need"><small>You need about</small><strong>' + needed + ' lb paste</strong><span>' + escapeHTML(formula) + '</span></div>' +
        '<div class="dc-paste-result-pack"><small>Suggested packs</small><b>' + escapeHTML(packParts.join(' + ') || (needed > 0 ? 'Unavailable' : 'Enter a project size')) + '</b><span>' + (packs.supplied ? packs.supplied + ' lb supplied' : '') + '</span></div>' +
        action +
        '<button class="dc-paste-result-link" type="button" data-open-color>Review ' + escapeHTML(name) + ' options</button>' +
        '<p class="dc-paste-calc-message" data-calc-message role="status" aria-live="polite"></p>';
      var open = result.querySelector('[data-open-color]');
      if (open) open.addEventListener('click', function () { openDetail(root, card, true); });
      var add = result.querySelector('[data-calc-add]');
      if (add) add.addEventListener('click', function () {
        var message = result.querySelector('[data-calc-message]');
        if (!window.DcPasteBuy || typeof window.DcPasteBuy.addItems !== 'function') {
          message.textContent = 'Cart controls are still loading. Refresh the page and try again.';
          message.className = 'dc-paste-calc-message bad';
          return;
        }
        var original = add.innerHTML;
        add.disabled = true;
        add.textContent = 'Adding…';
        message.textContent = '';
        message.className = 'dc-paste-calc-message';
        window.DcPasteBuy.addItems(cartItems)
          .then(function () {
            add.disabled = false;
            add.innerHTML = original;
            message.textContent = 'Added ' + packCount + ' recommended pack' + (packCount === 1 ? '' : 's') + ' to cart.';
            message.className = 'dc-paste-calc-message ok';
          })
          .catch(function (error) {
            add.disabled = false;
            add.innerHTML = original;
            message.textContent = error && error.message ? error.message : 'Could not add the recommended packs. Try again.';
            message.className = 'dc-paste-calc-message bad';
          });
      });
    }

    color.addEventListener('change', function () {
      var values = dosesFor(color.value);
      dose.innerHTML = doseOptions(color.value, values[0]);
      calculate();
    });
    dose.addEventListener('change', calculate);
    amount.addEventListener('input', calculate);
    amount.addEventListener('change', calculate);
    unit.addEventListener('change', calculate);
    calculator.querySelector('[data-calc-minus]').addEventListener('click', function () {
      amount.value = Math.max(0.5, (parseFloat(amount.value) || 0.5) - 0.5);
      calculate();
    });
    calculator.querySelector('[data-calc-plus]').addEventListener('click', function () {
      amount.value = (parseFloat(amount.value) || 0) + 0.5;
      calculate();
    });
    calculate();
  }

  function consolidateMethodNotes(root) {
    if (root.querySelector('.dc-paste-method')) return;
    var grid = root.querySelector('#dcpasteGrid');
    if (!grid) return;
    var candidates = root.querySelectorAll(':scope > .lead, :scope > .note');
    if (!candidates.length) return;
    var method = document.createElement('details');
    method.className = 'dc-paste-method';
    method.innerHTML = '<summary>About paste colors and dose estimates</summary><div></div>';
    var content = method.querySelector('div');
    Array.prototype.forEach.call(candidates, function (node) { content.appendChild(node); });
    grid.insertAdjacentElement('afterend', method);
  }

  function removeLegacyCalculators(root) {
    var candidates = document.querySelectorAll('[id="dcPasteCalc"], #dcpaste .dccalc');
    var current = null;
    Array.prototype.forEach.call(candidates, function (calculator) {
      var isCurrent = calculator.classList && calculator.classList.contains('dc-paste-calculator');
      if (isCurrent && root.contains(calculator) && !current) {
        current = calculator;
        return;
      }
      if (calculator.parentNode) calculator.parentNode.removeChild(calculator);
    });
    return current;
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    if (root.getAttribute('data-dc-paste-wired') === 'true') {
      prepareMobileMedia(root);
      removeLegacyCalculators(root);
      installCalculator(root);
      if (window.DcPasteBuy) window.DcPasteBuy.init(root);
      return;
    }
    root.setAttribute('data-dc-paste-wired', 'true');
    activeCard = null;
    activeDetail = null;
    activeMediaCard = null;
    requestedMediaCard = null;
    if (root.closest && root.closest('[id^="MainPasteProduct-"]')) {
      Array.prototype.forEach.call(root.querySelectorAll('#dcpasteGrid > .sw'), function (card) {
        card.setAttribute('aria-pressed', 'false');
      });
    }
    prepareMobileMedia(root);
    enhanceTitle(root);
    Array.prototype.forEach.call(root.querySelectorAll('.det'), enhanceDetail);
    consolidateMethodNotes(root);
    removeLegacyCalculators(root);
    installCalculator(root);

    root.addEventListener('click', function (event) {
      var close = event.target.closest ? event.target.closest('[data-close]') : null;
      if (close && root.contains(close)) {
        event.preventDefault();
        closeDetail(true);
        return;
      }
      var card = event.target.closest ? event.target.closest('#dcpasteGrid > .sw') : null;
      if (card && root.contains(card)) openDetail(root, card, true);
    });

    var wasMobileViewport = window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
    window.addEventListener('resize', function () {
      if (activeCard && activeDetail) placeDetail(root.querySelector('#dcpasteGrid'), activeCard, activeDetail);
      var isMobileViewport = window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
      if (isMobileViewport !== wasMobileViewport) {
        prepareMobileMedia(root);
        var mediaCard = requestedMediaCard || activeMediaCard;
        if (mediaCard) activateProductMedia(root, mediaCard);
      }
      wasMobileViewport = isMobileViewport;
    });
    if (window.DcPasteBuy) window.DcPasteBuy.init(root);
    openFromLink(root);
  }

  window.DcPasteUI = {
    init: init,
    openFromLink: function (search) {
      var root = document.getElementById(ROOT_ID);
      return root ? openFromLink(root, search) : false;
    },
    dosesFor: dosesFor,
    packaging: packaging,
    purchasablePackaging: purchasablePackaging,
    roundOne: roundOne,
    removeLegacyCalculators: removeLegacyCalculators
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
